import React, { useRef } from 'react';
import { useContext } from 'react';
//
import {Container, Box, Typography, Alert} from '@mui/material';
import Grid from '@mui/material/Grid';
//
import { AppContext } from '/@/app/AppContext';
import InsightsIcon from '@mui/icons-material/Insights';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
import { TableOfContents } from '/@/app/views/LabTestView/TableOfContents';
import { DynamicsChart, Legend } from '/@/app/components/DynamicsChart';
import { SectionItem } from '/@/app/views/LabTestView/Section';

export const DynamicsView = () => {
    const state = useContext(AppContext).labTestsSectionListState;
    const dynamics = useContext(AppContext).bootstrapData.panel_dynamics?.items;
    const { userData } = useContext(AppContext);
    const currentPanel = useContext(AppContext).bootstrapData.panel;

    // Prepare Table of Content anchors
    const refs = state.sections.map(() => useRef(null));

    // closure to refs the other props will be passed by the HelpingDrawerLayout
    const DrawerContent = ({drawerOpen, setDrawerOpen}) => {
        return <TableOfContents sectionElementRefs={refs} closeDrawer={() => setDrawerOpen(false)} />
    }

    if (dynamics === undefined) {
        return (
            <Alert severity="info" sx={{ mt: 2 }}>Динамика недоступна.</Alert>
        )
    }

    return (
        <HelpingDrawerLayout
            drawerContent={DrawerContent}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}
        >
            <Container maxWidth="md" sx={{
                p: { xs: "0!important" }, // fit the diagrams to the full width
            }}>
                <Box sx={{
                    pl: { xs: 0, sm: 2 },  // doesn't work on Container w/o '!important', so put here
                    pr: { xs: 0, sm: 2 },
                }}>
                    <Typography variant="h3" gutterBottom>
                        <InsightsIcon sx={{ fontSize: "35px", mr: 2 }} />
                        Динамика
                    </Typography>
                    <Legend size={16} sx={{ mb: 1 }}/>
                </Box>
            </Container>

            <Container maxWidth="md" sx={{
                p: { xs: "0!important" }, // fit the diagrams to the full width
            }}>
                <Grid container spacing={2}>
                    {state.sections.map((section, index) => (
                        <Grid item xs={12} key={index}>
                            <SectionItem ref={refs[index]} >
                                {section.section_name &&
                                    <Typography variant="h5" sx={{  }}>{section.section_name}</Typography>
                                }
                                {section.measurements.filter(mState => mState.xlsxId in dynamics).length === 0 &&
                                    <Alert severity="info" sx={{ mt: 2 }}>Здесь пока нет данных.</Alert>
                                }
                                {section.measurements
                                    .filter(mState => mState.xlsxId in dynamics)
                                    .map((mState, index) => (
                                        <Box key={index}>
                                            <Typography
                                                variant="h6"
                                                sx={{pt: 2, pb: 0}}
                                            >{mState.caption}</Typography>
                                            <Typography
                                                variant="body2"
                                                sx={{pt: 0, pb: 0}}
                                            >{mState.units}</Typography>
                                            <DynamicsChart
                                                data={dynamics[mState.xlsxId]}
                                                currentPanel={currentPanel}
                                                hideLegend={true}
                                                debugTools={userData.debug_mode}
                                            />
                                        </Box>
                                    ))
                                }
                            </SectionItem>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </HelpingDrawerLayout>
    );
}
